import React from "react";
import logo from "./image/logo.png";
import style from "./index.module.scss";

const NavBar = () => {
  return (
    <footer>
      <article>
        <img src={logo} alt="融达融资担保"></img>
        <p>
          联系电话：0755-82767942
          <br />
          联系邮箱：rd@szrzrd.com
          <br />
          联系地址：
          深圳市福田区福田街道福安社区益田路4068号卓越时代广场大厦4901-4905之4901A
        </p>
      </article>
      <p>
        版权所有©深圳市融达融资担保有限公司&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://beian.miit.gov.cn" title="https://beian.miit.gov.cn" target="_blank">粤ICP备2024272515号-1</a>
      </p>
    </footer>
  );
};

export default NavBar;
